<div [ngClass]="{
    'report-image': true,
    'selectable': reportIso.isSelectable,
    'selected': reportIso.isSelected,
    'edited': !reportIso.isSaved(),
    'mark': true,
    'highlight-hover' : designService.highlightElement
  }" [style.top]="reportIso.top" [style.left]="reportIso.left" [style.width]="reportIso.width"
  [style.height]="reportIso.height" (click)="onClick($event)" draggable="true" (dragstart)="onDragStart($event)"
  (dragover)="onDragOver($event)" (drop)="onDrop($event)">
  <p class="image-src"><b>{{'reportIso.interactiveISOimage' | translate}}</b></p>
</div>
